import { Checkbox } from '../../form/checkbox'

export const RowSelectionHeader = (props: any) => {
  const { table } = props
  const isMultiRowSelectionEnabled = table.options.enableMultiRowSelection !== false

  if (!isMultiRowSelectionEnabled) {
    return null
  }

  return (
    <Checkbox
      checked={table.getIsAllRowsSelected()}
      indeterminate={table.getIsSomeRowsSelected()}
      onChange={table.getToggleAllRowsSelectedHandler()}
    />
  )
}
